import { parseUnsignedInteger } from "./parse.js";
export function deserializeTimedState(scopes, parse) {
    const result = {
        tasks: {},
        calendars: {},
        markets: {},
    };
    for (const scope of Object.values(scopes)) {
        for (const [id, state] of Object.entries(scope.tasks ?? {}))
            result.tasks[id] = decodeTask(state, parse);
        for (const [id, state] of Object.entries(scope.calendars ?? {})) {
            result.calendars[id] = {
                phaseIndex: state.phaseIndex,
                elapsedMs: state.elapsedMs,
                cycle: parseUnsignedInteger(state.cycle, "calendar cycle"),
                boundaries: state.boundaries.map((boundary) => ({
                    ...boundary,
                    sequence: parseUnsignedInteger(boundary.sequence, "calendar boundary sequence"),
                    cycle: parseUnsignedInteger(boundary.cycle, "calendar boundary cycle"),
                })),
            };
        }
        for (const [id, state] of Object.entries(scope.markets ?? {})) {
            result.markets[id] = { bought: parse(state.bought), sold: parse(state.sold) };
        }
    }
    return result;
}
function decodeTask(state, parse) {
    const quantities = (values) => Object.fromEntries(Object.entries(values).map(([id, value]) => [id, parse(value)]));
    const claim = (value) => ({
        sequence: parseUnsignedInteger(value.sequence, "task claim sequence"),
        quantities: quantities(value.quantities),
    });
    return {
        nextSequence: parseUnsignedInteger(state.nextSequence, "task sequence"),
        queue: state.queue.map((entry) => ({
            sequence: parseUnsignedInteger(entry.sequence, "queued task sequence"),
            escrow: quantities(entry.escrow),
            outputs: quantities(entry.outputs),
        })),
        active: decodeActive(state.active, quantities),
        completed: state.completed.map(claim),
        refunds: state.refunds.map(claim),
    };
}
function decodeActive(active, quantities) {
    if (!active)
        return null;
    const common = {
        sequence: parseUnsignedInteger(active.sequence, "active task sequence"),
        escrow: quantities(active.escrow),
        outputs: quantities(active.outputs),
    };
    return active.mode === "fixed-duration"
        ? { ...common, mode: active.mode, remainingMs: active.remainingMs }
        : { ...common, mode: active.mode, remainingWork: active.remainingWork };
}
//# sourceMappingURL=deserialize-timed.js.map